import apiClient from './client';

export const adminApi = {
  // Users
  getUsers: (params) => apiClient.get('/api/admin/users', { params }),

  getUserById: (id) => apiClient.get(`/api/admin/users/${id}`),

  createUser: (data) => apiClient.post('/api/admin/users', data),

  updateUser: (id, data) => apiClient.put(`/api/admin/users/${id}`, data),

  deleteUser: (id) => apiClient.delete(`/api/admin/users/${id}`),

  getUserDetails: (id) => apiClient.get(`/api/admin/users/${id}/details`),

  // Clients
  getClients: (params) => apiClient.get('/api/admin/clients', { params }),

  getClientById: (id) => apiClient.get(`/api/admin/clients/${id}`),

  createClient: (data) => apiClient.post('/api/admin/clients', data),

  updateClient: (id, data) => apiClient.put(`/api/admin/clients/${id}`, data),

  deleteClient: (id) => apiClient.delete(`/api/admin/clients/${id}`),

  getClientDetails: (id) => apiClient.get(`/api/admin/clients/${id}/details`),

  // Categories
  getCategories: (params) => apiClient.get('/api/admin/categories', { params }),

  getCategoryById: (id) => apiClient.get(`/api/admin/categories/${id}`),

  createCategory: (data) => apiClient.post('/api/admin/categories', data),

  updateCategory: (id, data) => apiClient.put(`/api/admin/categories/${id}`, data),

  deleteCategory: (id) => apiClient.delete(`/api/admin/categories/${id}`),

  // Operator Categories
  getOperatorCategories: (params) => apiClient.get('/api/admin/operator-categories', { params }),

  createOperatorCategory: (data) => apiClient.post('/api/admin/operator-categories', data),

  updateOperatorCategory: (id, data) => apiClient.put(`/api/admin/operator-categories/${id}`, data),

  deleteOperatorCategory: (id) => apiClient.delete(`/api/admin/operator-categories/${id}`),

  // Pricing
  getPricing: () => apiClient.get('/api/admin/pricing'),

  updatePricing: (data) => apiClient.put('/api/admin/pricing', data),

  // Activity
  getActivity: (params) => apiClient.get('/api/admin/activity', { params }),

  // Attributes
  getAttributes: (params) => apiClient.get('/api/admin/attributes', { params }),

  createAttribute: (data) => apiClient.post('/api/admin/attributes', data),

  updateAttribute: (id, data) => apiClient.put(`/api/admin/attributes/${id}`, data),

  deleteAttribute: (id) => apiClient.delete(`/api/admin/attributes/${id}`),

  // Customer Rating
  getCustomerRatings: (params) => apiClient.get('/api/admin/customer-ratings', { params }),

  // Operator Review
  getOperatorReviews: (params) => apiClient.get('/api/admin/operator-reviews', { params }),

  updateOperatorReview: (id, data) => apiClient.put(`/api/admin/operator-reviews/${id}`, data),

  // Custom Message
  getCustomMessages: (params) => apiClient.get('/api/admin/custom-messages', { params }),

  updateCustomMessage: (id, data) => apiClient.put(`/api/admin/custom-messages/${id}`, data),

  // Lead Customer
  getLeadCustomers: (params) => apiClient.get('/api/admin/lead-customers', { params }),

  // Report Details
  getReportDetails: (params) => apiClient.get('/api/admin/report-details', { params }),

  // Template Status
  getTemplateStatus: (params) => apiClient.get('/api/admin/template-status', { params }),

  // Onboard Form
  getOnboardForms: (params) => apiClient.get('/api/admin/onboard-forms', { params }),

  createOnboardForm: (data) => apiClient.post('/api/admin/onboard-forms', data),

  updateOnboardForm: (id, data) => apiClient.put(`/api/admin/onboard-forms/${id}`, data),
};

export default adminApi;
